type ClaiStaffEmailUser = {
  primaryEmailAddressId: string | null;
  emailAddresses: Array<{
    id: string;
    emailAddress: string;
    verification?: { status?: string | null } | null;
  }>;
};

/** JWT/Clerk email suffix used as a cheap staff-domain prefilter. */
export const CLAI_STAFF_EMAIL_DOMAIN = '@goclai.com'; // pragma: allowlist secret

/**
 * True when `email` is on the Clai staff domain. Authorization still
 * requires a verified primary (see `isClaiStaff`) or an engineering
 * capability grant — this is only the free JWT/email-claim prefilter.
 */
export function isClaiStaffJwtEmail(email: string | null | undefined): boolean {
  return typeof email === 'string' && email.endsWith(CLAI_STAFF_EMAIL_DOMAIN);
}

/**
 * Checks if a Clerk user is verified Clai staff (@goclai.com).
 *
 * Validates that the user's primary email ends with @goclai.com
 * and has been verified through Clerk's email verification flow.
 */
export function isClaiStaff(user: ClaiStaffEmailUser): boolean {
  const primaryEmail = user.emailAddresses.find(
    e => e.id === user.primaryEmailAddressId
  );

  return (
    isClaiStaffJwtEmail(primaryEmail?.emailAddress) &&
    primaryEmail?.verification?.status === 'verified'
  );
}
